import { useContext, useState } from "react";
import { useEffect } from "react";
import { AuthContext } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../config";

import {
  FaBars,
  FaTimes,
  FaTachometerAlt,
  FaBoxOpen,
  FaClipboardList,
  FaUsers,
  FaCog,
  FaSignOutAlt,
} from "react-icons/fa";

import "./Dashboard.css";

function Dashboard() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("dashboard");
  const [editId, setEditId] = useState(null);
  const editProduct = (product)=>{

  setEditId(product.id);

  setProductData({
    name: product.name,
    price: product.price,
    description: product.description,
    image: null,
    image2: null
  });

  setActiveMenu("addProduct");

};
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const filteredProducts = products.filter((product)=>{

  return product.name
    .toLowerCase()
    .includes(search.toLowerCase());

});
  const [totalProducts, setTotalProducts] = useState(0);
  const getProductCount = async()=>{

  const res = await fetch(
    `${BASE_URL}/api/products/count`
  );

  const data = await res.json();

  if(data.success){
    setTotalProducts(data.total);
  }

};
  const getProducts = async()=>{

  const res = await fetch(
    `${BASE_URL}/api/products/allproducts`
  );

  const data = await res.json();

  if(data.success){
    setProducts(data.products);
  }

};
useEffect(()=>{

  getProductCount();

  if(activeMenu === "viewProducts"){
    getProducts();
  }

},[activeMenu]);

const deleteProduct = async(id)=>{

const confirmDelete = window.confirm(
"Are you sure you want to delete?"
);


if(!confirmDelete) return;


const res = await fetch(
`${BASE_URL}/api/products/${id}`,
{
method:"DELETE"
}
);


const data = await res.json();


if(data.success){

alert("Product Deleted");

getProducts();

}

};
const [productData, setProductData] = useState({
  name:"",
  price:"",
  description:"",
  image:null,
  image2: null
});
const handleProductChange = (e)=>{

  const {name,value,files}=e.target;

  setProductData({
    ...productData,
    [name]: files ? files[0] : value
  });

};



const addProduct = async(e)=>{

e.preventDefault();


const formData = new FormData();

formData.append("name", productData.name);
formData.append("price", productData.price);
formData.append("description", productData.description);


if(productData.image){
 formData.append("image", productData.image);
}
if (productData.image2) {
  formData.append("image2", productData.image2);
}



let url = `${BASE_URL}/api/products/add`;
let method = "POST";


if(editId){

 url = `${BASE_URL}/api/products/${editId}`;
 method = "PUT";

}



const res = await fetch(url,{
 method:method,
 body:formData
});


const data = await res.json();


if(data.success){

alert(
 editId 
 ? "Product Updated Successfully"
 : "Product Added Successfully"
);


setProductData({
 name:"",
 price:"",
 description:"",
 image:null,
 image2: null
});


setEditId(null);

setActiveMenu("viewProducts");

getProducts();

}


};
  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="dashboard">

      {/* Overlay */}

      {sidebarOpen && (
        <div
          className="overlay"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      {/* Sidebar */}

     <aside className={`admin-sidebar ${sidebarOpen ? "show" : ""}`}>

        <div>

          <div className="logo">

            <h2>SAH?</h2>

            <p>Admin Panel</p>

          </div>

        <ul className="admin-sidebar-menu">

  <li
    className={activeMenu === "dashboard" ? "active" : ""}
    onClick={() => {
      setActiveMenu("dashboard");
      setSidebarOpen(false);
    }}
  >
    <FaTachometerAlt />
    Dashboard
  </li>

  <li
    className={activeMenu === "addProduct" ? "active" : ""}
    onClick={() => {
      setActiveMenu("addProduct");
      setSidebarOpen(false);
    }}
  >
    <FaBoxOpen />
    Add Product
  </li>

  <li
    className={activeMenu === "viewProducts" ? "active" : ""}
    onClick={() => {
      setActiveMenu("viewProducts");
      setSidebarOpen(false);
    }}
  >
    <FaClipboardList />
    View Products
  </li>

</ul>

        </div>

        <button className="logout-btn" onClick={handleLogout}>
          <FaSignOutAlt />
          Logout
        </button>

      </aside>

      {/* Main */}

      <div className="main-content">

        {/* Header */}

        <header className="topbar">

          <div className="topbar-left">

            <button
              className="menu-btn"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              {sidebarOpen ? <FaTimes /> : <FaBars />}
            </button>

            <h3>
              {activeMenu.charAt(0).toUpperCase() +
                activeMenu.slice(1)}
            </h3>

          </div>

          <div className="admin-profile">

            <span>Welcome Admin</span>

          </div>

        </header>

        {/* Content */}
<div className="content">

  {activeMenu === "dashboard" && (

    <>
      <div className="cards">

        <div className="card">
         <h2>{totalProducts}</h2>
<p>Total Products</p>
        </div>

        <div className="card">
          <h2>0</h2>
          <p>Total Orders</p>
        </div>

      </div>

      <div className="welcome-box">

        <h2>Welcome Admin 👋</h2>

        <p>
          Welcome to SAH? Admin Dashboard.
        </p>

      </div>

    </>

  )}

  {activeMenu === "addProduct" && (

    <div className="page-box">

      <h2>Add Product</h2>

     <form 
className="product-form"
onSubmit={addProduct}
>

       <input
type="text"
name="name"
value={productData.name}
onChange={handleProductChange}
placeholder="Product Name"
/>

        <input
type="number"
name="price"
value={productData.price}
onChange={handleProductChange}
placeholder="Price"
/>

        <textarea
name="description"
value={productData.description}
onChange={handleProductChange}
placeholder="Description"
rows="5"
></textarea>

        <input
type="file"
name="image"
onChange={handleProductChange}
/>
<input
  type="file"
  name="image2"
  onChange={handleProductChange}
/>

<button className="save-btn">

{
 editId ? "Update Product" : "Add Product"
}

</button>

      </form>

    </div>

  )}

  {activeMenu === "viewProducts" && (

    <div className="page-box">

      <h2>All Products</h2>

<input
  type="text"
  placeholder="Search Product..."
  className="search-input"
  value={search}
  onChange={(e)=>setSearch(e.target.value)}
/>
      <table className="product-table">

        <thead>

          <tr>
          <th>Image</th>
<th>Name</th>
<th>Description</th>
<th>Price</th>
<th>Date</th>
<th>Action</th>
          </tr>

        </thead>
<tbody>

{
filteredProducts.length > 0 ? (

filteredProducts.map((product)=>(

<tr key={product.id}>

<td>

{
product.image ? (

<img
src={`https://sahscents.xpertoneevents.com/uploads/${product.image}`}
width="70"
height="70"
alt={product.name}
/>

) : (

"No Image"

)
}

</td>


<td>
{product.name}
</td>


<td>
{product.description}
</td>


<td>
AED {product.price}
</td>


<td>

{
new Date(product.created_at)
.toLocaleDateString("en-GB")
}

</td>


<td>

<button
className="edit-btn"
onClick={()=>editProduct(product)}
>
Edit
</button>


<button
className="delete-btn"
onClick={()=>deleteProduct(product.id)}
>
Delete
</button>


</td>


</tr>

))

) : (

<tr>

<td colSpan="6">
No Products Found
</td>

</tr>

)

}

</tbody>

      </table>

    </div>

  )}

</div>

      </div>

    </div>
  );
}

export default Dashboard;